import { render } from "./GiftSingle.vue?vue&type=template&id=0471518f&scoped=true"
import script from "./GiftSingle.vue?vue&type=script&lang=js"
export * from "./GiftSingle.vue?vue&type=script&lang=js"

import "./GiftSingle.vue?vue&type=style&index=0&id=0471518f&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0471518f"]])

export default __exports__